import { AgmCoreModule } from '@agm/core';
import { NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from 'app/pipes/pipes.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { SimulationGeneralReportListComponent } from './simulation-general-report-list/simulation-general-report-list.component';
import { SimulationGeneralZoneReportListComponent } from './simulation-general-zone-report-list/simulation-general-zone-report-list.component';
import { SimulationGeneralContainerReportListComponent } from './simulation-general-container-report-list/simulation-general-container-report-list.component';




@NgModule({
  declarations: [SimulationGeneralReportListComponent, SimulationGeneralContainerReportListComponent,SimulationGeneralZoneReportListComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    MatTableModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatCardModule,
    MatProgressBarModule,
    NgxMatDatetimePickerModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    MatChipsModule,
    MatSelectModule,
    MatExpansionModule,
    NgApexchartsModule,
    MatInputModule,
    MatPaginatorModule,
    MatRippleModule,
    MatSortModule,
    MatTabsModule,
    MatSnackBarModule,
    PipesModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TranslateModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
  })
  ],
})
export class SimulationGeneralReportModule { }
